/**
 * ResultMessage.success("保存成功")
 * ResultMessage.error("保存失败", {duration: 3000})
 */

import React from "react";
import { Icon, Modal } from "antd";
import style from "./index.module.scss";

const DefaultDuration = 1000;
const DefaultWidth = 200;

declare type getContainerFunc = () => HTMLElement;

export interface ResultMessageProps {
    duration?: number;
    width?: number;
    getContainer?: string | HTMLElement | getContainerFunc | false | null;
}

export class ResultMessage {
    static success(text: React.ReactNode, props?: ResultMessageProps) {
        const options = {
            duration: DefaultDuration,
            width: DefaultWidth,
            ...props
        };

        const modal = Modal.success({
            width: options.width,
            centered: true,
            maskClosable: true,
            content: (
                <div className={style.success}>
                    <Icon type="check-circle" theme="filled" />
                    <div>{text}</div>
                </div>
            ),
            getContainer: props?.getContainer,
            className: style.root
        });

        setTimeout(() => modal.destroy(), options.duration);
    }

    static error(text: React.ReactNode, props?: ResultMessageProps) {
        const options = {
            duration: DefaultDuration,
            width: DefaultWidth,
            ...props
        };

        const modal = Modal.success({
            width: options.width,
            centered: true,
            maskClosable: true,
            content: (
                <div className={style.error}>
                    <Icon type="close-circle" theme="filled" />
                    <div>{text}</div>
                </div>
            ),
            getContainer: props?.getContainer,
            className: style.root
        });

        setTimeout(() => modal.destroy(), options.duration);
    }
}
